import * as actionTypes from "./ActionTypes";
import AxiosNewInstance from "axios";
import Axios from "../../axios-instance";
export const addItemToCart = (id) => {
  return {
    type: actionTypes.ADD_ITEM,
    bookId: id,
  };
};

export const increaseItem = id => {
  return {
    type: actionTypes.INCREASE_ITEM,
    increasedIemID: id
  };
};

export const decreaseItem = id => {
  return {
    type: actionTypes.DECREASE_ITEM,
    decreaseItemId: id
  };
};

export const GetCountry = data => {
  return {
    type: actionTypes.GET_COUNTRY_LIST,
    country: data
  };
};

export const storeCountry = () => {
  return dispatch => {
    AxiosNewInstance.get("https://restcountries.eu/rest/v2/all").then(
      response => {
        var countrys = response.data;
        console.log(countrys)
        dispatch(GetCountry(countrys));
      }
    );
  };
};

export const initOrder = () => {
  return {
    type: actionTypes.INIT_ORDER_BOOK
  };
};

export const userShippingAddress = (address) => {
  // console.log(address)
  return {
    type: actionTypes.USER_SHIPPING_ADDRESS,
    userAddress : address
  };
};

export const orderCreated = (orderData) => {
  return {
    type: actionTypes.ORDER_BOOKED,
    orderDetail:orderData
  };
};

export const orderBook = (cartItem) => {
  return dispatch => {
    dispatch(initOrder());
    Axios.post(`/create/vk/order`, cartItem).then(response => {
      sessionStorage.setItem("orderID",response.data.order_id)
      dispatch(orderCreated(response.data))
    });
  };
};

export const checkout = (shippingCharge) => {
  return {
    type : actionTypes.CHECKOUT,
    shippingCharge : shippingCharge
  }
}

export const paymentSuccess = (orderResponse) => {
  return {
    type : actionTypes.PAYMENT_SUCCESS,
    orderStatus : orderResponse
  }
}

export const clearReducer = () => {
  return {
    type : actionTypes.CLEAR_REDUCER,
  }
}


export const initCheckPincode = () => {
  return {
    type : actionTypes.INIT_CHECK_PINCODE,
  }
}
export const getPincodeDetail = (pincodeDetail) => {
 return {
  type : actionTypes.CHECK_PINCODE,
  availability : pincodeDetail.is_available
 }
}
export const CheckPincode = (pincode) => {
  return dispatch=> {
    dispatch(initCheckPincode())
    Axios.post('/check/zip/code',pincode).then((response => {
      dispatch(getPincodeDetail(response.data))
    }))
  }
}